<div class="camadas">
  <div id="map3d"></div>
</div>
